import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import DarkMode from "./Darkmode";
import SideNav from "./Sidenav";

const Layout = (props) => {
  return (
    <>
      <div className="row g-0">
        <div className="col-md-11 col-xs-12 position-relative">
          <Header />
          <DarkMode />
          <main>{props.children}</main>
          <Footer />
        </div>
        <div className="col-md-1 col-xs-0 sidenav-wrapper">
          <SideNav />
        </div>
      </div>
    </>
  );
};

export default Layout;
